import { AzureSearchService } from './AzureSearchService';
import { IFacetValue, ISearchCriteria, ISearchResult } from './ISearchService';

import { ISearchState } from './ISearchState';

import { SortMetadata } from './SortMetadata';

export interface ISearchActionResult {
	fuzzy: boolean;
	result: ISearchResult
}

function ApplyWildcard (term: string): string {
	if (!term) return term;
	return term.replace(/([^\s*"")])(\s|$)/g, '$1* ');
}

function ApplyFuzzyMatch (term: string) {
	if (!term) return term;
	return term.replace(/([^\s~""])(\s|$)/g, '$1~ ');
}

export class SearchActions {
	public async SearchIndex (state: ISearchState): Promise<ISearchActionResult> {
		const filter = (state.filters && state.filters.length > 0)
			? state.filters.map((f) => f.expression).join(' and ')
			: '';

		const sort = SortMetadata.get(state.sort) || SortMetadata.default();

		const search = ApplyWildcard(state.query);

		const criteria: ISearchCriteria = {
			searchType: state.searchType,
			term: search,
			matchAll: true,
			filter,
			pageSize: state.pageSize,
			page: state.page,
			sort: sort.expression
		};

		const service = new AzureSearchService();

		let result = await service.search(criteria);

		const noMatch = result.count === 0;

		if (noMatch) {
			criteria.matchAll = false;
			if (criteria.term) {
				// switch to full parsing and use fuzzy search
				criteria.fullSearch = true;
				criteria.term = ApplyFuzzyMatch(state.query);
			}
			result = await service.search(criteria);
		}

		return { fuzzy: noMatch, result: result } as ISearchActionResult;
	}

	public async ExploreFacet (state: ISearchState, column: string) : Promise<IFacetValue[]> {
		const filter = (state.filters && state.filters.length > 0)
			? state.filters.map((f) => f.expression).join(' and ')
			: '';

		return this.GetFacets(state, filter, column);
	}

	public async GetAvailablePeriods (state: ISearchState): Promise<IFacetValue[]> {
		const filter = (state.filters && state.filters.length > 0)
			? state.filters.filter((f) => f.key !== 'yearTerm').map((f) => f.expression).join(' and ')
			: '';

		return this.GetFacets(state, filter, 'yearTerm');
	}

	private async GetFacets (state: ISearchState, filter: string, column: string): Promise<IFacetValue[]> {
		const criteria: ISearchCriteria = {
			searchType: state.searchType,
			term: ApplyWildcard(state.query),
			matchAll: true,
			filter
		};

		const service = new AzureSearchService();

		let result = await service.facet(criteria, column);

		const noMatch = !result || !result.length;

		if (noMatch) {
			criteria.matchAll = false;

			if (criteria.term) {
				// switch to full parsing and use fuzzy search
				criteria.fullSearch = true;
				criteria.term = ApplyFuzzyMatch(state.query);
			}

			result = await service.facet(criteria, column);
		}

		return result;
	}
}
